module.exports = __webpack_public_path__ + "img/BYOCS_Nutrition.3ea637f9.jpg";